import { SelectableCardProps } from "./types";

import "./styles.css";

const SelectableCard = ({
  icon,
  color,
  title,
  description,
  additionalData,
  additionalDataIcon,
  isActive,
  onClick,
}: SelectableCardProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`base-card flex flex-col gap-200 ${isActive ? "base-card-active" : ""}`}
      style={{
        border: isActive ? `0.125rem solid ${color}` : undefined,
        borderLeft: isActive
          ? `0.125rem solid ${color}`
          : `0.25rem solid ${color}`,
        backgroundColor: isActive ? `${color}1a` : "transparent",
      }}
      onClick={handleClick}
    >
      <div className="flex items-center gap-200">
        {icon && (
          <span
            style={{ backgroundColor: color }}
            className="base-card-icon flex items-center justify-center"
          >
            <img src={icon} alt="card icon" />
          </span>
        )}

        <span className="base-card-title header-s-medium">{title}</span>
      </div>

      <p className="base-card-description body-s-regular full-height full-width">
        {description}
      </p>

      {additionalData && (
        <div className="flex items-center gap-200">
          {additionalDataIcon}
          <span className="base-card-duration body-s-regular">
            {additionalData}
          </span>
        </div>
      )}
    </div>
  );
};

export default SelectableCard;
